export const TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE = 'HALCYON CONSENT & DISCLOSURE FORM';
